export const initialToolState = {
  activeTool: null,
  features: [],
  selectedFeature: null,
};

export default (state, action) => {
  const removeAllFeatures = () => {
    state.features.forEach((feature) => {
      feature.remove();
    });
  };

  switch (action.type) {
    case 'selectOrToogleActiveTool': {
      if (action.payload === null) {
        return { ...state, activeTool: null };
      }
      // else if (state.features.length > 0) {
      //   return state;
      // }
      else {
        const activeTool =
          state.activeTool === action.payload ? null : action.payload;
        return { ...state, activeTool };
      }
    }
    case 'selectFeature':
      return { ...state, selectedFeature: action.payload };
    case 'setFeatures':
      return { ...state, features: action.payload };
    case 'addFeature':
      return {
        ...state,
        features: [...state.features, action.payload],
      };

    case 'deleteAllFeatures': {
      if (action.payload?.silent) {
        removeAllFeatures();
        return initialToolState;
      } else {
        return state;
      }
    }
    case 'deleteFeature': {
      let newFeatures = state.features.filter((f) => {
        if (f._leaflet_id === action.payload) {
          f.remove();
          return false;
        } else {
          return true;
        }
      });
      return {
        ...state,
        features: newFeatures,
        activeTool: !newFeatures.length ? null : state.activeTool,
      };
    }

    default:
      throw new Error();
  }
};
